//POST TYPES
export const POST_DATA_REQUEST = "POST_DATA_REQUEST";
export const POST_COURSE_DATA_SUCCESS = "POST_COURSE_DATA_SUCCESS";
export const POST_BRANCH_DATA_SUCCESS = "POST_BRANCH_DATA_SUCCESS";
export const POST_SOURCE_DATA_SUCCESS = "POST_SOURCE_DATA_SUCCESS";
export const POST_CITY_DATA_SUCCESS = "POST_CITY_DATA_SUCCESS";
export const POST_WHATSIMAGE_DATA_SUCCESS = "POST_WHATSIMAGE_DATA_SUCCESS";
export const POST_STATUS_DATA_SUCCESS = "POST_STATUS_DATA_SUCCESS";
export const POST_USER_DATA_SUCCESS = "POST_USER_DATA_SUCCESS";
export const POST_SUPPORT_DATA_SUCCESS = "POST_SUPPORT_DATA_SUCCESS";
export const POST_ADMIN_DATA_SUCCESS = "POST_ADMIN_DATA_SUCCESS";
export const POST_LEAD_DATA_SUCCESS = "POST_LEAD_DATA_SUCCESS";
export const POST_LEAD_ASSIGN_SUCCESS = "POST_LEAD_ASSIGN_SUCCESS";
export const POST_SIGN_IN_SUCCESS = "POST_SIGN_IN_SUCCESS";
export const SET_SIGNIN_USER = "SET_SIGNIN_USER";
export const POST_SIGN_UP_SUCCESS = "POST_SIGN_UP_SUCCESS";
export const POST_SIGN_OUT_SUCCESS = "POST_SIGN_OUT_SUCCESS";
export const POST_LEAD_LOGS_SUCCESS = "POST_LEAD_LOGS_SUCCESS";
export const POST_SIDE_MENU_SUCCESS = "POST_SIDE_MENU_SUCCESS";
export const POST_TODO_DATA = "POST_TODO_DATA";
export const POST_PROPOSAL_SUCCESS = "POST_PROPOSAL_SUCCESS";
export const POST_GREETING_CATEGORY_SUCCESS = "POST_GREETING_CATEGORY_SUCCESS";
export const POST_CATEGORY_SUCCESS = "POST_CATEGORY_SUCCESS";
export const POST_CLIENT_PROPOSAL_EMAIL = "POST_CLIENT_PROPOSAL_EMAIL";
export const POST_SUPER_SIDEMENU = "POST_SUPER_SIDEMENU";
export const POST_DATA_FAILURE = "POST_DATA_FAILURE";
export const POST_FORGET_PASSWORD_REQUEST = "auth/request-forgot-password";
export const POST_FORGET_PASSWORD_SUCCESS = "/auth/forgot-password";
export const POST_EMAIL_TEMPLATE_DATA_SUCCESS =
  "POST_EMAIL_TEMPLATE_DATA_SUCCESS";
export const POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS =
  "POST_EMAIL_TEMPLATE_CATEGORY_SUCCESS";
export const POST_BULK_EMAIL_SEND_DATA_SUCCESS =
  "POST_BULK_EMAIL_SEND_DATA_SUCCESS";
export const POST_WHATSAPP_TEMPLATE_SUCCESS = "POST_WHATSAPP_TEMPLATE_SUCCESS";
export const POST_SMS_TEMPLATE_SUCCESS = "POST_SMS_TEMPLATE_SUCCESS";
export const POST_SUPER_USER_DATA_SUCCESS = "POST_SUPER_USER_DATA_SUCCESS";
export const POST_SUPER_BRANCH_SUCCESS = "POST_SUPER_BRANCH_SUCCESS";
export const POST_SUPER_CITY_DATA_SUCCESS = "POST_SUPER_CITY_DATA_SUCCESS";
export const POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS =
  "POST_SUPER_EMAIL_TEMPLATE_CATEGORY_SUCCESS";
export const POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS =
  "POST_SUPER_EMAIL_TEMPLATE_DATA_SUCCESS";
export const POST_DEMO_ENQUIRY_DATA_SUCCESS = "POST_DEMO_ENQUIRY_DATA_SUCCESS";

export const POST_COVER_IMAGE_EMAIL_SUCCESS = "POST_COVER_IMAGE_EMAIL_SUCCESS";
export const POST_IMAGE_CLOUDINARY_SUCCESS = "POST_IMAGE_CLOUDINARY_SUCCESS";
export const POST_NAVBAR_CONTENT_SUCCESS = "POST_NAVBAR_CONTENT_SUCCESS";
export const POST_LEGAL_CONTENT_SUCCESS = "POST_LEGAL_CONTENT_SUCCESS";
export const POST_CONTACT_ENQUIRY_SUCCESS = "POST_CONTACT_ENQUIRY_SUCCESS";
export const POSTFOOTERCONTENTSUCCESS = "POSTFOOTERCONTENTSUCCESS";
export const POST_PROPOSAL_TERMS_SUCCESS = "POST_PROPOSAL_TERMS_SUCCESS";
export const POST_TERMS_CATEGORY_SUCCESS = "POST_TERMS_CATEGORY_SUCCESS";

//GET TYPES
export const GET_DATA_REQUEST = "GET_DATA_REQUEST";
export const GET_BRANCH_DATA_SUCCESS = "GET_BRANCH_DATA_SUCCESS";
export const GET_COURSE_DATA_SUCCESS = "GET_COURSE_DATA_SUCCESS";
export const GET_SOURCE_DATA_SUCCESS = "GET_SOURCE_DATA_SUCCESS";
export const GET_CITY_DATA_SUCCESS = "GET_CITY_DATA_SUCCESS";
export const GET_PROPOSAL_DATA = "GET_PROPOSAL_DATA";
export const GET_PROPOSAL_GREETING_DATA = "GET_PROPOSAL_GREETING_DATA";
export const GET_GREETING_CATEGORY_DATA = "GET_GREETING_CATEGORY_DATA";
export const GET_WHATSIMAGE_DATA_SUCCESS = "GET_WHATSIMAGE_DATA_SUCCESS";
export const GET_CONTACT_DATA_SUCCESS = "GET_CONTACT_DATA_SUCCESS";
export const GET_STATUS_DATA_SUCCESS = "GET_STATUS_DATA_SUCCESS";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_SUPPORT_DATA_SUCCESS = "GET_SUPPORT_DATA_SUCCESS";
export const GET_ADMIN_DATA_SUCCESS = "GET_ADMIN_DATA_SUCCESS";
export const GET_LEAD_DATA_SUCCESS = "GET_LEAD_DATA_SUCCESS";
export const GET_LEAD_COUNT_SUCCESS = "GET_LEAD_COUNT_SUCCESS";
export const GET_COURSE_ANALYTICS_SUCCESS = "GET_COURSE_ANALYTICS_SUCCESS";
export const GET_SOURCE_ANALYTICS_SUCCESS = "GET_SOURCE_ANALYTICS_SUCCESS";
export const GET_SIDE_MENU_SUCCESS = "GET_SIDE_MENU_SUCCESS";
export const GET_EMAIL_TEPLATES_SUCCESS = "GET_EMAIL_TEPLATES_SUCCESS";
export const GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS =
  "GET_EMAIL_TEMPLATE_CATOGORY_SUCCESS";
export const GET_EMAIL_CAMPAIGN_REPORT = "GET_EMAIL_CAMPAIGN_REPORT";
export const GET_WHATSAPP_TEMPLATE_SUCCESS = "GET_WHATSAPP_TEMPLATE_SUCCESS";
export const GET_SMS_TEMPLATE_SUCCESS = "GET_SMS_TEMPLATE_SUCCESS";

export const GET_SUPER_DASHBOARD_TILES = "GET_SUPER_DASHBOARD_TILES";
export const GET_SUPER_ADMIN_REVENUE = "GET_SUPER_ADMIN_REVENUE";
export const GET_SUPER_USER_DATA_SUCCESS = "GET_SUPER_USER_DATA_SUCCESS";

export const GET_SUPER_TODO = "GET_SUPER_TODO";
export const GET_SUPER_SIDEMENU = "GET_SUPER_SIDEMENU";
export const GET_DATA_FAILURE = "GET_DATA_FAILURE";
export const GET_DEMO_ENQUIRY_SUCCESS = "GET_DEMO_ENQUIRY_SUCCESS";
export const GET_SUPER_GREETING_CATEGORIES_SUCCESS =
  "GET_SUPER_GREETING_CATEGORIES_SUCCESS";
export const GET_SUPER_PROPOSAL_GREETING_SUCCESS =
  "GET_SUPER_PROPOSAL_GREETING_SUCCESS";
export const GET_SUPER_BRANCH_DATA_SUCCESS = "GET_SUPER_BRANCH_DATA_SUCCESS";
export const GET_SUPER_CITY_DATA_SUCCESS = "GET_SUPER_CITY_DATA_SUCCESS";
export const GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS =
  "GET_SUPER_EMAIL_TEMPLATE_CATOGORY_SUCCESS";
export const GET_SUPER_EMAIL_TEMPLATES_SUCCESS =
  "GET_SUPER_EMAIL_TEMPLATES_SUCCESS";
export const GET_NAVBAR_CONTENT_SUCCESS = "GET_NAVBAR_CONTENT_SUCCESS";
export const GET_SINGLE_NAVBAR_CONTENT_SUCCESS =
  "GET_SINGLE_NAVBAR_CONTENT_SUCCESS";
export const GET_LEGAL_CONTENT_SUCCESS = "GET_LEGAL_CONTENT_SUCCESS";
export const GET_CONTACT_ENQUIRY_SUCCESS = "GET_CONTACT_ENQUIRY_SUCCESS";
export const GETFOOTERCONTENTSUCCESS = "GETFOOTERCONTENTSUCCESS";
export const GET_PROPOSAL_SUMMARY_SUCCESS = "GET_PROPOSAL_SUMMARY_SUCCESS";
export const GET_PROPOSAL_TERMS_DATA = "GET_PROPOSAL_TERMS_DATA";
export const GET_TERMS_CATEGORY_DATA = "GET_TERMS_CATEGORY_DATA";
export const GET_SUPER_TERMS_CATEGORIES_SUCCESS =
  "GET_SUPER_TERMS_CATEGORIES_SUCCESS";
export const GET_SUPER_PROPOSAL_TERMS_SUCCESS =
  "GET_SUPER_PROPOSAL_TERMS_SUCCESS";
export const GET_LEAD_SUMMARY_SUCCESS = "GET_LEAD_SUMMARY_SUCCESS";
export const GET_PAYMENT_DETAILS_SUCCESS = "GET_PAYMENT_DETAILS_SUCCESS";

//GET SINGLEDATA TYPES
export const GET_SINGLE_DATA_REQUEST = "GET_SINGLE_DATA_REQUEST";
export const GET_SINGLE_BRANCH_DATA_SUCCESS = "GET_SINGLE_BRANCH_DATA_SUCCESS";
export const GET_SINGLE_COURSE_DATA_SUCCESS = "GET_SINGLE_COURSE_DATA_SUCCESS";
export const GET_SINGLE_SOURCE_DATA_SUCCESS = "GET_SINGLE_SOURCE_DATA_SUCCESS";
export const GET_SINGLE_CITY_DATA_SUCCESS = "GET_SINGLE_CITY_DATA_SUCCESS";
export const GET_SINGLE_PROPOSAL = "GET_SINGLE_PROPOSAL";
export const GET_SINGLE_PROPOSAL_GREETING = "GET_SINGLE_PROPOSAL_GREETING";
export const GET_SINGLE_WHATSIMAGE_DATA_SUCCESS =
  "GET_SINGLE_WHATSIMAGE_DATA_SUCCESS";
export const GET_SINGLE_CONTACT_DATA_SUCCESS =
  "GET_SINGLE_CONTACT_DATA_SUCCESS";
export const GET_SINGLE_STATUS_DATA_SUCCESS = "GET_SINGLE_STATUS_DATA_SUCCESS";
export const GET_SINGLE_USER_DATA_SUCCESS = "GET_SINGLE_USER_DATA_SUCCESS";
export const GET_SINGLE_SUPPORT_DATA_SUCCESS =
  "GET_SINGLE_SUPPORT_DATA_SUCCESS";
export const GET_SINGLE_ADMIN_DATA_SUCCESS = "GET_SINGLE_USER_DATA_SUCCESS";
export const GET_SINGLE_LEAD_DATA_SUCCESS = "GET_SINGLE_LEAD_DATA_SUCCESS";
export const GET_SINGLE_SIDE_MENU_SUCCESS = "GET_SINGLE_SIDE_MENU_SUCCESS";
export const GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE =
  "GET_SUPER_SINGLE_PARTICULAR_ADMIN_REVENUE";
export const GET_SINGLE_SUPER_TODO = "GET_SINGLE_SUPER_TODO";
export const GET_SINGLE_SUPER_SIDEMENU = "GET_SINGLE_SUPER_SIDEMENU";
export const GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS =
  "GET_SINLGE_DEMO_EMQUIRY_DATA_SUCCESS";
export const GET_SINGLE_DATA_FAILURE = "GET_SINGLE_DATA_FAILURE";
export const GET_SINGLE_LEGAL_CONTENT_SUCCESS =
  "GET_SINGLE_LEGAL_CONTENT_SUCCESS";
export const GET_PUBLIC_LEGAL_CONTENT_SUCCESS =
  "GET_PUBLIC_LEGAL_CONTENT_SUCCESS";
export const GET_SINGLE_CONTACT_ENQUIRY_SUCCESS =
  "GET_SINGLE_CONTACT_ENQUIRY_SUCCESS";
export const GETSINGLEFOOTERCONTENTSUCCESS = "GETSINGLEFOOTERCONTENTSUCCESS";
export const GET_SINGLE_PROPOSAL_TERMS = "GET_SINGLE_PROPOSAL_TERMS";

// DELETE TYPES
export const DELETE_DATA_REQUEST = "DELETE_DATA_REQUEST";
export const DELETE_BRANCH_DATA_SUCCESS = "DELETE_BRANCH_DATA_SUCCESS";
export const DELETE_COURSE_DATA_SUCCESS = "DELETE_COURSE_DATA_SUCCESS";
export const DELETE_SOURCE_DATA_SUCCESS = "DELETE_SOURCE_DATA_SUCCESS";
export const DELETE_CITY_DATA_SUCCESS = "DELETE_CITY_DATA_SUCCESS";
export const DELETE_WHATSIMAGE_DATA_SUCCESS = "DELETE_WHATSIMAGE_DATA_SUCCESS";
export const DELETE_STATUS_DATA_SUCCESS = "DELETE_STATUS_DATA_SUCCESS";
export const DELETE_USER_DATA_SUCCESS = "DELETE_USER_DATA_SUCCESS";
export const DELETE_ADMIN_DATA_SUCCESS = "DELETE_USER_DATA_SUCCESS";
export const DELETE_LEAD_DATA_SUCCESS = "DELETE_LEAD_DATA_SUCCESS";
export const DELETE_SIDE_MENU_SUCCESS = "DELETE_SIDE_MENU_SUCCESS";
export const DELETE_TODO_DATA = "DELETE_TODO_DATA";
export const DELETE_SUPER_SIDEMENU = "DELETE_SUPER_SIDEMENU";
export const DELETE_DATA_FAILURE = "DELETE_DATA_FAILURE";
export const DELETE_GREETING_SUCCESS = "DELETE_GREETING_SUCCESS";
export const DELETE_EMAIL_TEMPLATE_SUCCESS = "DELETE_EMAIL_TEMPLATE_SUCCESS";
export const DELETE_WHATSAPP_TEMPLATE_SUCCESS =
  "DELETE_WHATSAPP_TEMPLATE_SUCCESS";
export const DELETE_SMS_TEMPLATE_SUCCESS = "DELETE_SMS_TEMPLATE_SUCCESS";
export const DELETE_PROPOSAL_SUCCESS = "DELETE_PROPOSAL_SUCCESS";
export const DELETE_NAVBAR_CONTENT_SUCCESS = "DELETE_NAVBAR_CONTENT_SUCCESS";
export const DELETE_LEGAL_CONTENT_SUCCESS = "DELETE_LEGAL_CONTENT_SUCCESS";
export const DELETE_CONTACT_ENQUIRY_SUCCESS = "DELETE_CONTACT_ENQUIRY_SUCCESS";
export const DELETEFOOTERCONTENTSUCCESS = "DELETEFOOTERCONTENTSUCCESS";
export const DELETE_TERMS_SUCCESS = "DELETE_TERMS_SUCCESS";

// UPDATE TYPES
export const UPDATE_DATA_REQUEST = "UPDATE_DATA_REQUEST";
export const UPDATE_BRANCH_DATA_SUCCESS = "UPDATE_BRANCH_DATA_SUCCESS";
export const UPDATE_COURSE_DATA_SUCCESS = "UPDATE_COURSE_DATA_SUCCESS";
export const UPDATE_SOURCE_DATA_SUCCESS = "UPDATE_SOURCE_DATA_SUCCESS";
export const UPDATE_CITY_DATA_SUCCESS = "UPDATE_CITY_DATA_SUCCESS";
export const UPDATE_WHATSIMAGE_DATA_SUCCESS = "UPDATE_WHATSIMAGE_DATA_SUCCESS";
export const UPDATE_STATUS_DATA_SUCCESS = "UPDATE_STATUS_DATA_SUCCESS";
export const UPDATE_USER_DATA_SUCCESS = "UPDATE_USER_DATA_SUCCESS";
export const UPDATE_PROPOSAL_DATA = "UPDATE_PROPOSAL_DATA";
export const UPDATE_PROPOSAL_GREETING_DATA = "UPDATE_PROPOSAL_GREETING_DATA";
export const UPDATE_ADMIN_DATA_SUCCESS = "UPDATE_USER_DATA_SUCCESS";
export const UPDATE_LEAD_DATA_SUCCESS = "UPDATE_LEAD_DATA_SUCCESS";
export const UPDATE_LOGCOURSE_DATA_SUCCESS = "UPDATE_LOGCOURSE_DATA_SUCCESS";
export const UPDATE_SIDE_MENU_SUCCESS = "UPDATE_SIDE_MENU_SUCCESS";
export const UPDATE_SUPPORT_DATA_SUCCESS = "UPDATE_SUPPORT_DATA_SUCCESS";
export const UPDATE_SUPER_TODO = "UPDATE_SUPER_TODO";
export const UPDATE_SUPER_SIDEMENU = "UPDATE_SUPER_SIDEMENU";
export const UPDATE_DATA_FAILURE = "UPDATE_DATA_FAILURE";
export const UPDATE_EMAIL_TEMPLATE_DATA = "UPDATE_EMAIL_TEMPLATE_DATA";
export const UPDATE_WHATSAPP_TEMPLATE_DATA = "UPDATE_WHATSAPP_TEMPLATE_DATA";
export const UPDATE_SMS_TEMPLATE_DATA = "UPDATE_SMS_TEMPLATE_DATA";
export const UPDATE_DEMO_ENQUIRY_DATA_SUCCESS =
  "UPDATE_DEMO_ENQUIRY_DATA_SUCCESS";
export const UPDATE_SUPER_USER_DATA_SUCCESS = "UPDATE_SUPER_USER_DATA_SUCCESS";
export const UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS =
  "UPDATE_SUPER_PROPOSAL_GREETING_SUCCESS";
export const UPDATE_SUPER_BRANCH_DATA_SUCCESS =
  "UPDATE_SUPER_BRANCH_DATA_SUCCESS";
export const UPDATE_SUPER_CITY_DATA_SUCCESS = "UPDATE_SUPER_CITY_DATA_SUCCESS";
export const UPDATE_SUPER_EMAIL_TEMPLATE_DATA =
  "UPDATE_SUPER_EMAIL_TEMPLATE_DATA";
export const UPDATE_NAVBAR_CONTENT_SUCCESS = "UPDATE_NAVBAR_CONTENT_SUCCESS";
export const UPDATE_LEGAL_CONTENT_SUCCESS = "UPDATE_LEGAL_CONTENT_SUCCESS";
export const UPDATE_CONTACT_ENQUIRY_SUCCESS = "UPDATE_CONTACT_ENQUIRY_SUCCESS";
export const UPDATEFOOTERCONTENTSUCCESS = "UPDATEFOOTERCONTENTSUCCESS";
export const UPDATE_PROPOSAL_TERMS_DATA = "UPDATE_PROPOSAL_TERMS_DATA";
export const UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS =
  "UPDATE_SUPER_PROPOSAL_TERMS_SUCCESS";
export const MARK_PROPOSAL_AS_SENT_SUCCESS = "MARK_PROPOSAL_AS_SENT_SUCCESS";
export const CANCEL_PROPOSAL_SUCCESS = "CANCEL_PROPOSAL_SUCCESS";
export const SEND_PAYMENT_REMAINDER_MAIL = "SEND_PAYMENT_REMAINDER_MAIL";
export const UPDATE_PROPOSAL_PAYMENT_MODE_SUCCESS =
  "UPDATE_PROPOSAL_PAYMENT_MODE_SUCCESS";

// LEAD CONFIG TYPES
export const GET_LEAD_FIELD_CONFIG_SUCCESS = "GET_LEAD_FIELD_CONFIG_SUCCESS";
export const POST_LEAD_FIELD_CONFIG_SUCCESS = "POST_LEAD_FIELD_CONFIG_SUCCESS";

// ACCOUNT TYPES
export const POST_ACCOUNT_DATA_SUCCESS = "POST_ACCOUNT_DATA_SUCCESS";
export const GET_ACCOUNT_DATA_SUCCESS = "GET_ACCOUNT_DATA_SUCCESS";
export const UPDATE_ACCOUNT_DATA_SUCCESS = "UPDATE_ACCOUNT_DATA_SUCCESS";
export const DELETE_ACCOUNT_DATA_SUCCESS = "DELETE_ACCOUNT_DATA_SUCCESS";

// ADMISSION TYPES
export const POST_ADMISSION_DATA_SUCCESS = "POST_ADMISSION_DATA_SUCCESS";
export const GET_ADMISSION_DATA_SUCCESS = "GET_ADMISSION_DATA_SUCCESS";
export const UPDATE_ADMISSION_DATA_SUCCESS = "UPDATE_ADMISSION_DATA_SUCCESS";
export const DELETE_ADMISSION_DATA_SUCCESS = "DELETE_ADMISSION_DATA_SUCCESS";
export const SEND_ADMISSION_PAYMENT_REMAINDER_MAIL =
  "SEND_ADMISSION_PAYMENT_REMAINDER_MAIL";
export const UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS =
  "UPDATE_ADMISSION_PAYMENT_MODE_SUCCESS";
export const UPDATE_MANUAL_PAYMENT_SUCCESS = "UPDATE_MANUAL_PAYMENT_SUCCESS";
export const GET_SINGLE_ADMISSION_DATA_SUCCESS =
  "GET_SINGLE_ADMISSION_DATA_SUCCESS";

// In-app notifications (bell + notifications page)
export const NOTIFICATIONS_BOOTSTRAP = "NOTIFICATIONS_BOOTSTRAP";
export const NOTIFICATIONS_NEW = "NOTIFICATIONS_NEW";
export const NOTIFICATIONS_SET_UNREAD_COUNT = "NOTIFICATIONS_SET_UNREAD_COUNT";
export const NOTIFICATIONS_MARK_READ_LOCAL = "NOTIFICATIONS_MARK_READ_LOCAL";
export const NOTIFICATIONS_MARK_ALL_READ_LOCAL =
  "NOTIFICATIONS_MARK_ALL_READ_LOCAL";
export const NOTIFICATIONS_REMOVE_LOCAL = "NOTIFICATIONS_REMOVE_LOCAL";
